<template>
    <v-app id="artist">
        <v-navigation-drawer v-model="drawer" app clipped class=" tw-z-50">
            <v-list>
                <v-list-item class="px-2">
                    <v-list-item-avatar>
                        <v-img max-height="46px" max-width="46px" v-if="loaded == true && pageOptions.logo" :src="pageOptions.logo" class="tw-rounded-full tw-object-cover" />
                        <v-img max-height="46px" max-width="46px" v-else-if="loaded == true && (artist.post_image && !pageOptions.logo)" :src="artist.post_image" class="tw-rounded-full tw-object-cover" />
                        <v-img max-height="46px" max-width="46px" v-else-if="loaded == true && (!artist.post_image && !pageOptions.logo)" :src="spotifyArtist.images[2].url" class="tw-object-cover tw-rounded-full" />
                    </v-list-item-avatar>
                    <v-list-item-title class="tw-truncate tw-font-sans">{{loaded == true ? artist.artista_nome : ''}}</v-list-item-title>
                </v-list-item>
                <div class="tw-p-2">
                    <v-btn href="#" @click="follow({currentUser: currentUser, artist: artist}); clickFollow()" v-if="!following" block class="waves-effect dialogActivator tw-bg-white tw-text-black tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none"><i class="fas fa-plus tw-mr-1"></i><span class="tw-leading-none">{{selectedLanguage == 'US' ? en.bt_follow : pt.bt_follow}}</span></v-btn>
                    <v-btn href="#" @click="follow({currentUser: currentUser, artist: artist})" v-if="following" block class="waves-effect tw-rounded-full tw-border-2 tw-bg-transparent tw-border-white tw-text-white tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none"><i class="fas fa-minus tw-mr-2"></i><span class="tw-leading-none">{{selectedLanguage == 'US' ? en.bt_following :  pt.bt_following}}</span></v-btn>
                </div>
            </v-list>
            <v-divider></v-divider>
            <v-list dense class="tw-font-sans">
                <v-list-item link @click.prevent="$vuetify.goTo('#musics', {offset: 200})">
                    <v-list-item-content>
                        <v-list-item-title>{{selectedLanguage == 'US' ? en.menu_title_1 : pt.menu_title_1}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click.prevent="$vuetify.goTo('#albuns', {offset: 200})" v-if="loaded == true && Object.keys(albums).length">
                    <v-list-item-content>
                        <v-list-item-title>{{selectedLanguage == 'US' ? en.menu_title_2 : pt.menu_title_2}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click.prevent="$vuetify.goTo('#about')" v-if="loaded == true && artist.options.bio">
                    <v-list-item-content>
                        <v-list-item-title>{{selectedLanguage == 'US' ? en.menu_title_3 : pt.menu_title_3}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click.prevent="$vuetify.goTo('#playlists')" v-if="loaded == true && Object.keys(playlists).length">
                    <v-list-item-content>
                        <v-list-item-title>{{selectedLanguage == 'US' ? en.menu_title_4 : pt.menu_title_4}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click.prevent="$vuetify.goTo('#shows')" v-if="loaded == true && Object.keys(shows).length">
                    <v-list-item-content>
                        <v-list-item-title>{{selectedLanguage == 'US' ? en.menu_title_5 : pt.menu_title_5}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link @click.prevent="$vuetify.goTo('#contact')" v-if="loaded == true && pageOptions && pageOptions.email">
                    <v-list-item-content>
                        <v-list-item-title>{{selectedLanguage == 'US' ? en.menu_title_6 : pt.menu_title_6}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <div class="tw-p-2">
                <v-btn href="#" @click.prevent="backstageLink()" v-if="loaded == true && artist.backstage ? artist.backstage.page_active == 1 : false" block class="waves-effect tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none">{{artist.backstage.label.length ? artist.backstage.label : 'Backstage'}}</v-btn>
            </div>
        </v-navigation-drawer>
        <v-app-bar app color="black" dark clipped-left flat id="menu" class=" tw-z-30">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="tw-flex md:tw-hidden"></v-app-bar-nav-icon>
            <v-img max-height="48px" max-width="48px" width="48px" height="48px" aspect-ratio="1" v-if="loaded == true && pageOptions.logo" :src="pageOptions.logo" class="tw-rounded-full tw-object-cover" />
            <v-img max-height="48px" max-width="48px" width="48px" height="48px" aspect-ratio="1" v-else-if="loaded == true && !artist.post_image" :src="spotifyArtist.images[2].url" class="tw-object-cover tw-rounded-full" />
            <v-btn href="#" @click="Object.keys(currentUser).length ? follow({currentUser: currentUser, artist: artist}) : activateLoginPopup(); clickFollow();" v-if="!following && artista_id !== artist.artista_id" class="dialogActivator waves-effect tw-rounded-full tw-px-5 tw-py-2 tw-bg-white tw-text-black tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none tw-ml-1 tw-transform tw-scale-90 tw-hidden md:tw-flex"><i class="fas fa-plus tw-mr-1"></i><span class="tw-leading-none">{{selectedLanguage == 'US' ? en.bt_follow : pt.bt_follow}}</span></v-btn>
            <v-btn href="#" @click="follow({currentUser: currentUser, artist: artist})" v-if="following && artista_id !== artist.artista_id" class="waves-effect tw-px-5 tw-py-2 tw-rounded-full tw-hidden md:tw-flex tw-border-2 tw-bg-transparent tw-border-white tw-text-white tw-font-sans tw-text-xs tw-font-black tw-uppercase tw-tracking-wide tw-leading-none tw-ml-1 tw-transform tw-scale-90"><i class="fas fa-minus tw-mr-2"></i><span class="tw-leading-none">{{selectedLanguage == 'US' ? en.bt_following : pt.bt_following}}</span></v-btn>
            <v-spacer></v-spacer>
            <v-tabs right class="tw-mr-2 tw-font-sans tw-hidden md:tw-block" color="white">
                <v-tab class="tw-text-xs tw-tracking-widest" @click.prevent="$vuetify.goTo('#musics', {offset: 200})">{{selectedLanguage == 'US' ? en.menu_title_1 : pt.menu_title_1}}</v-tab>
                <v-tab class="tw-text-xs tw-tracking-widest" @click.prevent="$vuetify.goTo('#albums')" v-if="loaded == true && Object.keys(albums).length">{{selectedLanguage == 'US' ? en.menu_title_2 : pt.menu_title_2}}</v-tab>
                <v-tab class="tw-text-xs tw-tracking-widest" @click.prevent="$vuetify.goTo('#about')" v-if="loaded == true && artist.options.bio">{{selectedLanguage == 'US' ? en.menu_title_3 : pt.menu_title_3}}</v-tab>
                <v-tab class="tw-text-xs tw-tracking-widest" @click.prevent="$vuetify.goTo('#playlists')" v-if="loaded == true && Object.keys(playlists).length">{{selectedLanguage == 'US' ? en.menu_title_4 : pt.menu_title_4}}</v-tab>
                <v-tab class="tw-text-xs tw-tracking-widest" @click.prevent="$vuetify.goTo('#shows')" v-if="loaded == true && Object.keys(shows).length">{{selectedLanguage == 'US' ? en.menu_title_5 : pt.menu_title_5}}</v-tab>
                <v-tab class="tw-text-xs tw-tracking-widest" @click.prevent="$vuetify.goTo('#contact')" v-if="loaded == true && pageOptions && pageOptions.email">{{selectedLanguage == 'US' ? en.menu_title_6 : pt.menu_title_6}}</v-tab>
            </v-tabs>
            <v-btn class="tw-text-xs tw-tracking-widest tw-mr-2 tw-hidden md:tw-block" @click.prevent="backstageLink()" v-if="loaded == true && artist.backstage ? artist.backstage.page_active == 1 : false">{{artist.backstage.label.length ? artist.backstage.label : 'Backstage'}}</v-btn>
            <a :href="artist.options.facebookUrl" target="_blank" class="tw-mx-2 tw-flex tw-items-center" v-if="loaded == true && artist.options.facebookUrl && artist.options.facebookUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-facebook</v-icon>
            </a>
            <a :href="artist.options.instagramUrl" target="_blank" class="tw-mx-2 tw-flex tw-items-center" v-if="loaded == true && artist.options.instagramUrl && artist.options.instagramUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-instagram</v-icon>
            </a>
            <a :href="artist.options.twitterUrl" target="_blank" class="tw-mx-2 tw-flex tw-items-center" v-if="loaded == true && artist.options.twitterUrl && artist.options.twitterUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-twitter</v-icon>
            </a>
            <a :href="'https://open.spotify.com/artist/'+artist.options.spotifyUrl" target="_blank" class="tw-mx-2 tw-flex tw-items-center" v-if="loaded == true && artist.options.spotifyUrl && artist.options.spotifyUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-spotify</v-icon>
            </a>
            <a :href="'https://youtube.com/channel/'+artist.options.youtubeUrl" target="_blank" class="tw-mx-2 tw-flex tw-items-center" v-if="loaded == true && artist.options.youtubeUrl && artist.options.youtubeUrl !== '#'">
                <v-icon dark class="tw-text-lg">fab fa-youtube</v-icon>
            </a>
            <a v-if="loaded == true && artist.options.lojaVirtualUrl !== 'undefined' ? (artist.options.lojaVirtualUrl ? artist.options.lojaVirtualUrl : false) : false" :href="artist.options.lojaVirtualUrl" target="_blank" class="tw-mx-2 tw-flex tw-items-center"> 
                <v-icon dark class="tw-text-lg">fas fa-store</v-icon>
            </a>
            <div class="tw-flex tw-items-center md:tw-w-48 tw-w-14 tw-justify-end">
                <a @click="switchLanguage('BR')" class="tw-text-xs tw-leading-none tw-px-1 tw-py-1 tw-rounded tw-flex tw-justify-center tw-items-center">
                    <img src="/imgs/flags/pt_br.svg" class="tw-w-5 md:tw-mr-2 tw-mr-0" /> <span class="md:tw-block tw-hidden tw-text-white">BR</span> 
                </a>
                <a @click="switchLanguage('US')" class="tw-text-xs tw-leading-none tw-px-1 tw-py-1 tw-rounded tw-flex tw-justify-center tw-items-center">
                    <img src="/imgs/flags/en.svg" class="tw-w-5 md:tw-mr-2 tw-mr-0" /> <span class="md:tw-block tw-hidden tw-text-white">US</span>
                </a>
            </div>
        </v-app-bar>
        <login-dialog v-if="!Object.keys(this.currentUser).length" />
        <v-main>
            <v-container fluid class="tw-p-0">
                <slot />
            </v-container>
        </v-main>
        <app-footer :artist="artist" v-if="loaded" />
    </v-app>
</template>

<script>
import AppFooter from '@/Shared/Footer';
import EventBus from '@/eventbus';
import {TheMask} from 'vue-the-mask'
import LoginDialog from '@/components/login-popup';
import {mapState, mapActions} from 'vuex';
import pt from "../lang/smartsite/layout_1/layout_1.js";

export default {
    mixins: [pt],
    components: {TheMask, AppFooter, LoginDialog},
    data: () => ({
        drawer: false,
        pageOptions: '',
        artist: '',
        spotifyArtist: '',
        playlists: '',
        shows: '',
        albums: '',
        loaded: false,
        dialog: false,
        selectedLanguageObj : {},
        nameRules: [
            v => !!v || 'Nome é obrigatório',
            v => (v && v.length <= 32) || 'Nome precisa ter menos de 32 caracteres.',
        ],
        emailRules: [
            v => !!v || 'E-mail é obrigatório',
            v => /.+@.+\..+/.test(v) || 'Email precisa ser válido.',
        ],
    }),
    computed: {
        ...mapState('followstatus', ['following']),
        selectedLanguage() { 
            return this.$page.props.lang
        }
    },
    methods: {
        switchLanguage(language){
            var local = document.location;
            axios.post("/switch-lang", {language: language})
            .then(() => local.reload())
        },
        ...mapActions('followstatus', ['follow', 'checkStatus']),
        backstageLink(){
            this.$inertia.visit(this.tenant ? '/backstage' : '/artist/'+this.artist.artista_url+'/backstage');
        },
        activateLoginPopup(){
            EventBus.$emit('activatePopup');
        }, 
        clickFollow(){
            EventBus.$emit('clickFollow');
        },
        setLanguage() {
      if(this.$page.props.lang == 'US') {
        this.selectedLanguageObj = pt.data().en
      } else {
        this.selectedLanguageObj = pt.data().pt
      }
    }
    },
    created(){
        let vm = this;
        EventBus.$on('artist', function (data) {
            vm.pageOptions = data.pageOptions;
            vm.artist = data.artist;
            vm.spotifyArtist = data.spotifyArtist;
            vm.shows = data.shows;
            vm.albums = data.albums;
            vm.playlists = data.playlists;
            vm.loaded = true
            
            vm.checkStatus({
                currentUser: vm.currentUser,
                artist: vm.artist,
            });
        });
    },
    mounted(){
        let vm = this;
        EventBus.$on('followUser', e => {
            vm.follow({currentUser: vm.currentUser, artist: vm.artist});
        });

        console.log(this.language)
    },
    watch: {
        currentUser(newVal, oldVal){
            if(Object.keys(newVal).length){
                this.checkStatus({
                    currentUser: this.currentUser,
                    artist: this.artist,
                });
            }
        }
    },
}
</script>

<style>
    #artist{
        background: #1f1f1f;
    }
    #menu .v-tabs-slider{
        display: none!important;
    }
</style>